/* global common */
import {
  libInit,
  prefetchImageFromSource,
  sendGoogleEvent,
  isObjectFitSupported,
  byWindowAction, sendAmplitudeEvent,
} from '@html/_common/utils';

export default function HeroImageGalleryGrid(tdpEventCategory, imageGalleryLightboxManager, scrollTo) {
  const $mainHeroImageWrapper = $('.js-ao-tour-hero-image-wrapper');
  const $gridGalleryImageItem = $('.js-ao-tour-hero-image-gallery-item');
  const $gridGalleryReviewItem = $('.js-ao-tour-hero-image-gallery-review');
  const $gridGalleryVideoOverlay = $('.js-ao-tour-hero-image-gallery-video-overlay');
  const $gridGalleryVideoIframe = $('.js-ao-tour-hero-image-gallery-video-iframe');

  let imageUrls = null;
  let currentImageIndex = 0;
  let isOpeningPopup = false;

  this.common = typeof sendGoogleEvent !== 'undefined' ? {
    prefetchImageFromSource,
    sendGoogleEvent,
    isObjectFitSupported,
    byWindowAction,
    lib: { init: libInit },
  } : common;

  this.initiate = (newImageUrls) => {
    const preparedImageUrls = this.setupImageUrls(newImageUrls);

    this.initiateGalleryPopup(preparedImageUrls);
    this.setupClickEvents();
  };

  this.initiateGalleryPopup = (imageSources) => {
    imageGalleryLightboxManager.createNewImageGallery(imageSources, {
      openElementSelector: '.js-ao-tour-modal-trigger',
      startingIndex: () => this.getCurrentIndex(),
      lowerResolutionImageSize: '232x150',
      higherResolutionImageSize: '1500x800',
      openCallback: () => {
        isOpeningPopup = true;
      },
      googleEvents: {
        category: tdpEventCategory,
        eventGalleryName: 'Hero',
        actionVariations: [
          {
            className: 'js-ao-tour-hero-image-wrapper',
            action: 'With image click',
          },
        ],
      },
    });
  };

  this.setupImageUrls = (additionalImageUrls) => {
    const startingImageUrl = $mainHeroImageWrapper.data('starting-image-url');
    const imageAlreadyExists = startingImageUrl.split('/').pop() === additionalImageUrls[0].split('/').pop();
    imageUrls = additionalImageUrls[0].includes('youtube') || imageAlreadyExists ? additionalImageUrls : [startingImageUrl, ...additionalImageUrls];
    return imageUrls;
  };

  this.setupClickEvents = () => {
    $gridGalleryImageItem.on('click', (event) => {
      event.preventDefault();
      event.stopPropagation();

      const $clickedElement = $(event.currentTarget);
      currentImageIndex = $clickedElement.data('image-count');
      $('.js-ao-tour-modal-trigger').click();

      sendAmplitudeEvent({
        ampEventName: 'tdp_hero_gallery_clicked',
        tdp_hero_gallery: 'Multi-media',
        tdp_hero_gallery_type_clicked: 'Operator Photo',
        tdp_hero_gallery_position: currentImageIndex + 1,
      });
    });

    $gridGalleryReviewItem.on('click', () => {
      scrollTo('reviews', '', '');

      sendAmplitudeEvent({
        ampEventName: 'tdp_hero_gallery_clicked',
        tdp_hero_gallery: 'Multi-media',
        tdp_hero_gallery_type_clicked: 'Customer Review',
      });
    });

    // Track video playing state
    let isVideoPlaying = true;

    // Handle left-clicks on overlay to toggle video play/pause
    $gridGalleryVideoOverlay.on('click', (event) => {
      if (isOpeningPopup) {
        isVideoPlaying = true;
        isOpeningPopup = false;
        const $lightboxVideoOverlay = $('.js-ao-tour-image-gallery__video-overlay');
        $lightboxVideoOverlay.removeClass('ao-tour-image-gallery__main-video-overlay--play');
        $lightboxVideoOverlay.addClass('ao-tour-image-gallery__main-video-overlay--pause');
      }

      const clickOffsetY = event.offsetY;
      const overlayHeight = $gridGalleryVideoOverlay.height();
      const overlayHeightThird = overlayHeight / 3;
      const isClickInTheMiddle = clickOffsetY > overlayHeightThird && clickOffsetY < overlayHeightThird * 2;

      if (!isClickInTheMiddle) {
        event.preventDefault();
        event.stopPropagation();

        const $clickedElement = $(event.currentTarget).parent().find($gridGalleryVideoIframe);
        currentImageIndex = $clickedElement.data('image-count');
        return $('.js-ao-tour-modal-trigger').click();
      }

      sendAmplitudeEvent({
        ampEventName: 'tdp_hero_gallery_video',
        tdp_hero_gallery: 'Multi-media',
        tdp_hero_gallery_type_clicked: isVideoPlaying ? 'Pause' : 'Play',
      });

      const iframe = $gridGalleryVideoIframe[0];
      const videoFunc = isVideoPlaying ? 'pauseVideo' : 'playVideo';
      if (iframe?.contentWindow) {
        iframe.contentWindow.postMessage(`{"event":"command","func":"${videoFunc}","args":""}`, '*');
        $(event.currentTarget)
          .addClass(isVideoPlaying ? 'ao-tour-hero-image-gallery-video-overlay--play' : 'ao-tour-hero-image-gallery-video-overlay--pause')
          .removeClass(isVideoPlaying ? 'ao-tour-hero-image-gallery-video-overlay--pause' : 'ao-tour-hero-image-gallery-video-overlay--play');
        isVideoPlaying = !isVideoPlaying;
        return true;
      }

      return false;
    });
  };

  this.getCurrentIndex = () => currentImageIndex;
}
